/**
 * @deprecated Import from '@/components/molecules' or '@/molecules' instead.
 * This file is kept for backwards compatibility during migration.
 */

export { MaskInput } from '@/components/molecules/form-fields';
export type { MaskInputProps } from '@/components/molecules/form-fields';
